import { useScrollAnimation } from "../../../utils/Utils";

const Image_ContentReusableComponent = ({
  heading,
  subheading,
  paragraph,
  imgsrc,
  reverse = true,
  bgColor = "#efefef",
  headingColor = "#000000",
  headingSize = "2rem", 
  textColor = "#333333"
}) => {
  useScrollAnimation();
  return (
    <section style={{ backgroundColor: bgColor }} className="py-5 lg:py-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:mx-36 mx-3 md:mx-10 gap-10">
        {/* Content */}
        <div
          className={`flex flex-col justify-between ${
            reverse ? "lg:order-2" : "lg:order-1"
          } order-2 animate-up`}
        >
          <div className="my-auto">
            <h1 style={{ color: headingColor,fontSize:headingSize }}>{heading}</h1>
            {subheading && <p className="desc" style={{ color: textColor }}>{subheading}</p>}
            <p style={{
              color: textColor,
              wordBreak: 'normal',
              overflowWrap: 'normal',
              hyphens: 'none',
              whiteSpace: 'normal'
            }}
          >{paragraph}</p>
          </div>
        </div>
        <div
          className={`flex ${
            reverse ? "lg:order-1" : "lg:order-2"
          } order-1 animate-up`}
        >
          <img
            src={imgsrc}
            alt="imgsrc"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Image_ContentReusableComponent;

  